import React from "react";
import { connect } from "react-redux";
import { Col } from 'react-bootstrap';
import PropTypes from "prop-types";
import ConditionalDropdown from "../../../layout/conditional-dropdown";
import { send as pageInfo } from "../../../actions/page";
import Agenda from "../agenda";
import LeadWidget from "../leads";
import BoardTaskWidget from "../board-tasks";
import FaxWidget from "../faxes";
import { FEATURES, has as hasFeature } from "../../../constants/features";
import { withNavigation } from "../../../utils/wrapper";

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.agendaRef = React.createRef();
        this.state = {
            
        };
        
    }

    componentDidUpdate = (oldProps) => {
        
    }

    componentDidMount = async () => {
        setTimeout(() => {
            this.loadData();
        }, 30);
    }

    loadData = async () => {
        await this.props.pageInfo({ title: "My Dashboard", breadcrumb: `` });
    }

    onNewEventClick = () => {
        this.agendaRef.current?.newEvent?.();
    };

    onNewPersonClick = () => {
        this.props.navigate("/dashboard/people/add");
    };

    onNewCompanyClick = () => {
        this.props.navigate("/dashboard/companies/add");
    };

    onNewMatterClick = () => {
        this.props.navigate("/dashboard/matters/add");
    };

    createTypes = () => ([
        {
            description: "Create a person record",
            caption: "Person",
            icon: "user",
            onClick: this.onNewPersonClick
        },
        {
            description: "Create a company record",
            caption: "Company",
            icon: "building",
            onClick: this.onNewCompanyClick
        },
        {
            description: "Create a matter",
            caption: "Matter",
            icon: "suitcase",
            onClick: this.onNewMatterClick
        },
        {
            description: "Create event",
            caption: "Event",
            icon: "calendar",
            onClick: this.onNewEventClick
        }
    ]);

    render() {
        return (
            <>
                {/* Title End */}
                <Col md="8" className="float-right text-end">
                    <ConditionalDropdown
                        enabledVariant="outline-primary"
                        display
                        enabled
                        items={this.createTypes()}
                        icon="plus"
                    >
                        New
                    </ConditionalDropdown>
                </Col>
                <Col lg="6">
                    <Agenda ref={this.agendaRef} />
                </Col>
                <Col lg="6" className="mt-4 mt-lg-0">
                    <BoardTaskWidget />
                </Col>
                <Col lg="6" className="mt-4">
                    <FaxWidget />
                </Col>
                {hasFeature(FEATURES.LEADS) ? (
                    <Col lg="6" className="mt-4">
                        <LeadWidget />
                    </Col>
                ) : null}
            </>
        )
    }
}

Profile.propTypes = {
    auth: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, {  pageInfo })(Profile));
